exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "/* stylelint-disable no-duplicate-selectors */\n/* stylelint-disable */\n/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */\n/* -------- Colors -----------*/\n/* system-color */\n/* font-color */\n/* status-color */\n.gc_Renewal_modal_box {\n  width: 80%;\n}\n", ""]);

